export enum Role {
  User = 'User',
  Customer = 'Customer',
  ProductConfigurator = 'Product Configurator',
  Producer = 'Producer',
  Reseller = 'Reseller',
  Supplier = 'Supplier',
  SupplierAdmin = 'SupplierAdmin',
  Admin = 'Admin',
}
